import React, { useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import { setUIAction } from '../../actions'
import { selfCheckRequest } from '../../actions/api'
import { UI } from '../../constants/ui'
import { AppState } from '../../reducers'

const CHECK_INTERVAL_MS = 60000

const mapStateToProps = (state: AppState) => ({
    uiState: state.ui.uiState,
})
type StateProps = ReturnType<typeof mapStateToProps>

interface DispatchProps {
    setUI: (ui: UI) => void
}
const mapDispatchToProps = (dispatch: any): DispatchProps => ({
    setUI: (ui: UI): void => dispatch(setUIAction(ui)),
})

type Props = DispatchProps & StateProps

const SelfCheckService: React.FC<Props> = ({ uiState, setUI }) => {
    const uiStateRef = useRef(uiState)
    uiStateRef.current = uiState

    useEffect(() => {
        let timer: any
        const checkConnection = async () => {
            try {
                await selfCheckRequest()
                if (uiStateRef.current === UI.OUT_OF_SERVICE) {
                    setUI(UI.MAIN)
                }
            } catch (e) {
                console.log('self check error', e)
                setUI(UI.OUT_OF_SERVICE)
            }
            timer = setTimeout(checkConnection, CHECK_INTERVAL_MS)
        }
        checkConnection()
        return () => { timer && clearTimeout(timer) }
    }, [])
    return null
}

export default connect(mapStateToProps, mapDispatchToProps)(SelfCheckService)